import React from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

const WelcomeHeaderWidget: React.FC<WidgetProps> = ({ config }) => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';

  if (!state) return null;

  const customerName = config.customerName || state.backgroundInfo.customerName || 'Welcome';
  const goalText = config.goalText || state.backgroundInfo.context || '';

  return (
    <div className="flex flex-col justify-center h-full px-8 py-6 gap-4">
      <h1 className={`text-7xl font-bold leading-tight ${
        isDark ? 'text-primary' : 'text-primary-dark'
      }`}>
        Welcome {customerName}
      </h1>
      {goalText && (
        <p className={`text-3xl whitespace-pre-wrap leading-relaxed ${
          isDark ? 'text-white/70' : 'text-slate-600'
        }`}>
          <span className={`font-semibold ${isDark ? 'text-white/90' : 'text-slate-800'}`}>Goal: </span>
          {goalText}
        </p>
      )}
    </div>
  );
};

export default WelcomeHeaderWidget;
